import React from 'react';
import LiteratureVerifier from './LiteratureVerifier';
import './App.css';

function App() {
  return (
    <div className="App">
      <LiteratureVerifier />
    </div>
  );
}

export default App;
